// Cache version is controlled by the server and mirrored to client cookie/session keys.

import {browserGetCookie, browserSetCookie} from "./browser.js";
import CONFIG from "./../config.json";

let _cacheTime = null;
const CACHE_TIME_COOKIE = "cacheTime";

function cacheSetCacheTime(value)
{
    _cacheTime = value;
}

function cacheGetCacheTime()
{
    return _cacheTime;
}

function cacheParseVersion(value)
{
    const parsed = parseInt(value, 10);
    if (Number.isFinite(parsed) && parsed > 0)
    {
        return parsed;
    }
    return 0;
}

function cacheSetVersionCookie(version)
{
    if (version > 0)
    {
        const value = version.toString();
        browserSetCookie(CACHE_TIME_COOKIE, value, 1);
        cacheSetCacheTime(value);
    } else
    {
        cacheSetCacheTime(null);
    }
}

function cacheClearClientIndexMaps()
{
    if (typeof window === "undefined")
    {
        return;
    }
    try
    {
        for (let i = sessionStorage.length - 1; i >= 0; i--)
        {
            const key = sessionStorage.key(i);
            if (key && (key.startsWith("postersIndexMap:") || key.startsWith("postersOthersIndexMap:") || key.startsWith("mapsVegueriaCache:") || key.startsWith("vegueriaRegions:")))
            {
                sessionStorage.removeItem(key);
            }
        }
    } catch (err)
    {
        // Ignore storage failures.
    }
}

async function cacheRequestJson(url, options = {})
{
    const response = await fetch(url, {
        cache: "no-store",
        ...options
    });

    if (!response.ok)
    {
        throw new Error(`Request failed (${response.status}) for ${url}`);
    }

    return response.json();
}

async function cacheFetchServerVersion()
{
    const payload = await cacheRequestJson("/cache/version");
    return cacheParseVersion(payload.cacheVersion);
}

async function cacheFlushServerVersion()
{
    const payload = await cacheRequestJson("/flush", {
        method: "POST"
    });
    return cacheParseVersion(payload.cacheVersion);
}

function cacheIsQuickReload() {
    let lastUnloadTime = browserGetCookie("lastUnloadTime");
    let lastUnloadURL = browserGetCookie("lastUnloadURL");
    let currentURL = window.location.href;
    let now = new Date().getTime();
    let ret = false;

    if (lastUnloadTime && lastUnloadURL === currentURL) {
        let timeDifference = now - lastUnloadTime;
        if (timeDifference < 5000) {
            ret = true;
        }
    }

    browserSetCookie("lastUnloadTime", now, 1);
    browserSetCookie("lastUnloadURL", currentURL, 1);

    return ret;
}

async function IfQuickReloadFlushEverything()
{
    let version = cacheParseVersion(browserGetCookie(CACHE_TIME_COOKIE));
    cacheSetVersionCookie(version);

    if (cacheIsQuickReload())
    {
        cacheClearClientIndexMaps();
        try
        {
            const apiResponse = await fetch(`${CONFIG.posters_api_url}/flush`, {
                cache: "no-store"
            });
            if (!apiResponse.ok)
            {
                throw new Error(`API cache flush failed (${apiResponse.status})`);
            }
            const flushedVersion = await cacheFlushServerVersion();
            if (flushedVersion > version)
            {
                version = flushedVersion;
            }
        } catch (err)
        {
            console.error("Unable to flush caches", err);
            throw err;
        }

        cacheSetVersionCookie(version);

        if (typeof window !== "undefined")
        {
            const reloadUrl = new URL(window.location.href);
            reloadUrl.searchParams.set("index", "0");
            reloadUrl.searchParams.set("cacheTime", version.toString());
            // The automatic navigation must not trigger another flush.
            browserSetCookie("lastUnloadURL", "", 1);
            window.location.replace(reloadUrl.toString());
            await new Promise(() => {});
        }
        return;
    }

    try
    {
        const serverVersion = await cacheFetchServerVersion();
        if (serverVersion > version)
        {
            version = serverVersion;
            cacheClearClientIndexMaps();
        }
    } catch (err)
    {
        // Keep cookie version when server version request fails.
    }

    cacheSetVersionCookie(version);
}

export {IfQuickReloadFlushEverything, cacheGetCacheTime};
